<script>
  import classNames from 'classnames';
  import { getPercentChange } from '../utils';

  export let previous;
  export let current;
  export let className = '';
</script>

<span
  class={classNames(className, {
    'text-green-500': previous - current < 0,
    'text-red-500': previous - current > 0,
  })}
>
  {getPercentChange(previous, current)}
</span>
<slot />
